import React from 'react';
import PropTypes from 'prop-types';
import {Badge} from '@albert-io/atomic';

import {statusTypes} from '../assignmentPracticeView.utils';

import './submission-status-badge.scss';

const statusData = {
  [statusTypes.submitted]: {
    label: 'Submitted',
    color: 'success'
  },
  [statusTypes.inProgress]: {
    label: 'In Progress',
    color: 'progress'
  },
  [statusTypes.notStarted]: {
    label: 'Not Started',
    color: 'emphasized'
  }
};

const SubmissionStatusBadge = ({status}) => {
  const {label, color} = statusData[status];
  return (
    <Badge className='submission-status-badge' color={color}>
      {label}
    </Badge>
  );
};

SubmissionStatusBadge.propTypes = {
  status: PropTypes.oneOf(Object.values(statusTypes))
};

export default SubmissionStatusBadge;
